module.exports = __webpack_public_path__ + "media/images/page-not-found/page-not-found-70c8ff265550c846adc8c149026edafc.png";